import { render, staticRenderFns } from "./AddFoodEl.vue?vue&type=template&id=77af0046&scoped=true"
import script from "./AddFoodEl.vue?vue&type=script&lang=js"
export * from "./AddFoodEl.vue?vue&type=script&lang=js"
import style0 from "./AddFoodEl.vue?vue&type=style&index=0&id=77af0046&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77af0046",
  null
  
)

export default component.exports